<template>
  <div>
    <div class="custom-control custom-switch mb-3">
      <input
        :id="`vehicle-unidentified-${_uid}`"
        v-model="value.unidentified"
        type="checkbox"
        class="custom-control-input"
        :disabled="disabled"
      >
      <label
        class="custom-control-label"
        :for="`vehicle-unidentified-${_uid}`"
      >
        {{ $t('involvedForm.vehicle.unidentifiedToggle') }}
      </label>
    </div>

    <div class="row">
      <div class="col-md-4 form-group">
        <label>{{ $t('involvedForm.vehicle.plate.label') }}</label>
        <input
          v-model="value.plate"
          type="text"
          class="form-control text-uppercase"
          :disabled="disabled"
          :placeholder="$t('involvedForm.vehicle.plate.placeholder')"
          maxlength="10"
          @blur="$emit('lookup-key', value.plate)"
        >
      </div>
      <div class="col-md-4 form-group">
        <label>{{ $t('involvedForm.vehicle.type.label') }}</label>
        <select
          v-model="value.vehicle_type"
          class="form-control"
          :disabled="disabled"
        >
          <option value="">
            {{ $t('involvedForm.vehicle.type.emptyOption') }}
          </option>
          <option value="carro">
            {{ $t('involvedForm.vehicle.type.options.car') }}
          </option>
          <option value="moto">
            {{ $t('involvedForm.vehicle.type.options.motorcycle') }}
          </option>
          <option value="caminhao">
            {{ $t('involvedForm.vehicle.type.options.truck') }}
          </option>
          <option value="onibus">
            {{ $t('involvedForm.vehicle.type.options.bus') }}
          </option>
          <option value="outro">
            {{ $t('involvedForm.vehicle.type.options.other') }}
          </option>
        </select>
      </div>
      <div class="col-md-4 form-group">
        <label>{{ $t('involvedForm.vehicle.color.label') }}</label>
        <input
          v-model="value.color"
          type="text"
          class="form-control"
          :disabled="disabled"
          :placeholder="$t('involvedForm.vehicle.color.placeholder')"
        >
      </div>

      <div class="col-md-5 form-group">
        <label>{{ $t('involvedForm.vehicle.brand.label') }}</label>
        <input
          v-model="value.brand"
          type="text"
          class="form-control"
          :disabled="disabled"
          :placeholder="$t('involvedForm.vehicle.brand.placeholder')"
        >
      </div>
      <div class="col-md-5 form-group">
        <label>{{ $t('involvedForm.vehicle.model.label') }}</label>
        <input
          v-model="value.model"
          type="text"
          class="form-control"
          :disabled="disabled"
          :placeholder="$t('involvedForm.vehicle.model.placeholder')"
        >
      </div>
      <div class="col-md-2 form-group">
        <label>{{ $t('involvedForm.vehicle.year.label') }}</label>
        <input
          v-model="value.year"
          type="text"
          class="form-control"
          :disabled="disabled"
          :placeholder="$t('involvedForm.vehicle.year.placeholder')"
          maxlength="9"
        >
      </div>

      <div class="col-md-6 form-group">
        <label>{{ $t('involvedForm.vehicle.renavam.label') }}</label>
        <input
          v-model="value.renavam"
          type="text"
          class="form-control"
          :disabled="disabled"
          :placeholder="$t('involvedForm.vehicle.renavam.placeholder')"
          maxlength="20"
        >
      </div>
      <div class="col-md-6 form-group">
        <label>{{ $t('involvedForm.vehicle.chassis.label') }}</label>
        <input
          v-model="value.chassis"
          type="text"
          class="form-control text-uppercase"
          :disabled="disabled"
          :placeholder="$t('involvedForm.vehicle.chassis.placeholder')"
          maxlength="30"
        >
      </div>

      <div
        v-if="value.unidentified"
        class="col-12 form-group"
      >
        <label>{{ $t('involvedForm.vehicle.apparentDescription.label') }}</label>
        <input
          v-model="value.apparent_description"
          type="text"
          class="form-control"
          :disabled="disabled"
          :placeholder="$t('involvedForm.vehicle.apparentDescription.placeholder')"
        >
      </div>

      <div class="col-12 form-group">
        <label>{{ $t('involvedForm.vehicle.observation.label') }}</label>
        <textarea
          v-model="value.observation"
          class="form-control"
          rows="2"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvolvedVehicleForm',
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
}
</script>
